"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.createBarInput = void 0;
exports.determineActivityType = determineActivityType;
exports.formatData = formatData;

var _sortBy = _interopRequireDefault(require("lodash/sortBy"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function groupToBar(group, colorScale) {
  var groupId = group.groupId,
      name = group.name,
      participationRate = group.participationRate;
  return {
    id: groupId,
    value: participationRate,
    label: name,
    fill: colorScale(groupId)
  };
}

function ratePercentage(subset, total) {
  return total === 0 ? null : Math.round(subset / total * 10000) / 100;
}

function determineActivityType(participation) {
  return participation.map(function (_ref) {
    var value = _ref.value;
    if (value < 30) return 'LOW';else if (value < 60) return 'OK';
    return 'HIGH';
  }).reduce(function (acc, type) {
    if (acc.isDiverse) return acc;
    if (acc.type !== type && acc.type) return {
      type: type,
      isDiverse: true
    };
    return {
      type: type,
      isDiverse: false
    };
  }, {
    type: null,
    isDiverse: false
  });
} // TODO: Add memoization when colors have been decoupled


function formatData(participation, theme, colorScale) {
  var sortedParticipation = participation.map(function (group) {
    return _objectSpread(_objectSpread({}, group), {}, {
      participationRate: ratePercentage(group.participantActiveCount, group.participantCount),
      // make sure we are not running out of colors
      fill: colorScale(group.groupId)
    });
  }).sort(function (groupA, groupB) {
    return groupA.participationRate - groupB.participationRate;
  });
  var count = sortedParticipation.reduce(function (acc, _ref2) {
    var participantCount = _ref2.participantCount;
    return acc + participantCount;
  }, 0);
  var activeCount = sortedParticipation.reduce(function (acc, _ref3) {
    var participantActiveCount = _ref3.participantActiveCount;
    return acc + participantActiveCount;
  }, 0);
  var sum = {
    groupId: 'ffffffff-ffff-ffff-ffff-ffffffffffff',
    name: 'All',
    participantCount: count,
    participantActiveCount: activeCount,
    participationRate: ratePercentage(activeCount, count),
    fill: theme.main.primary
  };
  var formattedParticipation = sortedParticipation.map(function (g) {
    return groupToBar(g, colorScale);
  });
  formattedParticipation = (0, _sortBy.default)(formattedParticipation, function (p) {
    return p.value;
  });

  var _determineActivityTyp = determineActivityType(formattedParticipation),
      type = _determineActivityTyp.type,
      isDiverse = _determineActivityTyp.isDiverse;

  return {
    type: type,
    isDiverse: isDiverse,
    sortedParticipation: sortedParticipation,
    sum: sum,
    formattedSum: [groupToBar(sum, function () {
      return theme.main.primary;
    })],
    lowest: formattedParticipation[0],
    highest: formattedParticipation.slice(-1)[0]
  };
}

var createBarInput = function createBarInput(participation) {
  return participation.map(function (_ref4) {
    var groupId = _ref4.groupId,
        name = _ref4.name,
        participationRate = _ref4.participationRate,
        fill = _ref4.fill;
    return {
      id: groupId,
      value: participationRate,
      label: name,
      fill: fill
    };
  });
};

exports.createBarInput = createBarInput;
var _default = {
  determineActivityType: determineActivityType,
  formatData: formatData,
  createBarInput: createBarInput
};
exports.default = _default;
//# sourceMappingURL=activity.js.map